import { render, staticRenderFns } from "./OrdenesContraActividad.vue?vue&type=template&id=ba3438bc&scoped=true&"
import script from "./OrdenesContraActividad.vue?vue&type=script&lang=js&"
export * from "./OrdenesContraActividad.vue?vue&type=script&lang=js&"
import style0 from "./OrdenesContraActividad.vue?vue&type=style&index=0&id=ba3438bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3438bc",
  null
  
)

export default component.exports